var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon08(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.688 7.735V5.84c0-.445.368-.813.812-.813.444 0 .813.368.813.813v1.895a.811.811 0 1 1-1.626 0zM13.02 7.735V5.84c0-.445.37-.813.813-.813.444 0 .813.368.813.813v1.895a.811.811 0 1 1-1.625 0zM17.354 7.735V5.84c0-.445.369-.813.813-.813.444 0 .812.368.812.813v1.895a.811.811 0 1 1-1.625 0zM22.132 11.983c-.802-1.311-2.232-2.2-3.879-2.2H10.27a4.568 4.568 0 0 0-4.56 4.561v.575h17.105v-.575c0-.205-.032-.411-.065-.606 1.571.466 2.73 1.896 2.73 3.618 0 1.7-1.126 3.12-2.665 3.597v-4.951H5.708v6.272a4.568 4.568 0 0 0 4.561 4.561h7.984c2.384 0 4.323-1.841 4.518-4.181a5.414 5.414 0 0 0 4.333-5.298c0-2.838-2.199-5.135-4.972-5.373z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon08);
export default __webpack_public_path__ + "static/media/icon-08.360b3d9d14bc51cec35e31387a9686c0.svg";
export { ForwardRef as ReactComponent };